"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabNavigator = void 0;
const HtmlWidget_1 = require("../../views/widgets/HtmlWidget");
class TabNavigator {
    constructor() {
        this.bodyElementType = "div";
        this.panelClassName = "tabcontent";
        this.buttonClassName = "tablinks";
        this.tabs = [];
    }
    addTabMenuButton(menuDiv, tabName) {
        let tabButton = document.createElement("button");
        tabButton.classList.add(this.buttonClassName);
        tabButton.textContent = tabName;
        menuDiv.appendChild(tabButton);
        return tabButton;
    }
    addTabMenuPanel(html, panelId, tabButton, defaultRenderPanel = false) {
        let panelTabDiv = new HtmlWidget_1.HtmlWidget(this.bodyElementType, "");
        panelTabDiv.shouldAppendChild = true;
        panelTabDiv.renderBody.classList.add(this.panelClassName);
        if (!defaultRenderPanel) {
            panelTabDiv.element.style.display = "none";
        }
        panelTabDiv.renderBody.id = panelId;
        tabButton.addEventListener("click", (evt) => {
            evt.preventDefault();
            this.openMenuTab(evt.currentTarget, panelTabDiv.renderBody.id);
        });
        return panelTabDiv;
    }
    openMenuTab(button, tabId) {
        for (let i = 0; i < this.tabs.length; i++) {
            this.tabs[i].tabPanel.element.style.display = "none";
        }
        for (let i = 0; i < this.tabs.length; i++) {
            this.tabs[i].tabButton.className = this.tabs[i].tabButton.className.replace(" active", "");
        }
        this.tabs.find(tab => tab.tabPanel.element.id === tabId).tabPanel.element.style.display = "block";
        button.className += " active";
    }
    addTabMenuItem(tabName, tabId, defaultMenuItem, additionalData) {
        let tabButton = this.addTabMenuButton(this.menuDiv, tabName);
        let tabPanel = this.addTabMenuPanel(this.parentContainer, tabId, tabButton, defaultMenuItem);
        this.parentContainer.appendChild(tabPanel.element);
        this.tabs.push({ tabButton: tabButton, tabPanel: tabPanel, additionalData: additionalData });
        if (defaultMenuItem) {
            this.openMenuTab(tabButton, tabPanel.element.id);
        }
        return tabPanel;
    }
}
exports.TabNavigator = TabNavigator;
//# sourceMappingURL=ITabNavigator.js.map